"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarUserMenu = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const index_1 = require("@ant-design/icons/es/icons/index");
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const TextTruncated_1 = require("src/hello_assets/src/components/ui/common/common/TextTruncated");
const lodash_1 = __importDefault(require("lodash"));
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
const MixpanelAnalytics_1 = require("src/hello_assets/src/util/analytics/MixpanelAnalytics");
const ToolbarUserMenu = () => {
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectExists = !lodash_1.default.isEmpty(currentProjectContext);
    const handleLogout = async () => {
        antd_1.Modal.confirm({
            visible: true,
            title: "Log Out",
            icon: null,
            content: React.createElement(React.Fragment, null, "Are you sure you want to log out?"),
            onOk: async () => {
                await authProviderContext.logout(authProviderContext.source);
                MixpanelAnalytics_1.MixpanelAnalytics.Business.trackSignOut({ source: authProviderContext.source });
                return;
            },
            okButtonProps: {
                danger: true
            },
            autoFocusButton: null
        });
    };
    const items = [];
    items.push({
        type: "group",
        label: "My Profile",
        children: [{ key: "profile", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Profile.home() }, "Profile") }]
    });
    if (projectExists) {
        items.push({ type: "divider" });
        items.push({
            type: "group",
            label: React.createElement(TextTruncated_1.TextTruncated, { text: currentProjectContext.projectName, length: 40 }),
            children: [{ key: "projectMembers", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.members(currentProjectContext.projectApiKey) }, "Members") }]
        });
    }
    items.push({ type: "divider" });
    items.push({ key: "projects", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.PATH__PROJECTS }, "Projects") });
    items.push({ type: "divider" });
    items.push({ key: "legal", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.PATH__LEGAL }, "Terms of Service") });
    items.push({ type: "divider" });
    items.push({ key: "logout", label: React.createElement("button", { onClick: handleLogout, className: "ug-text ug-text-full-width" }, "Logout") });
    const menu = React.createElement(antd_1.Menu, { items: items, style: { minWidth: "200px" } });
    return React.createElement(antd_1.Dropdown, { overlay: menu, trigger: ["click"], placement: "bottomRight" },
        React.createElement(antd_1.Avatar, { size: 32, icon: React.createElement(index_1.SettingOutlined, null), className: "userMenu" }));
};
exports.ToolbarUserMenu = ToolbarUserMenu;
